module.exports = __webpack_public_path__ + "img/1-22.1415a8e7.png";